/* eslint-disable */
import {Pressable, StyleSheet, Text, View} from 'react-native';
import ChevronLeft from '../assets/icons/chevron-left.svg';
import {colors, radii, shadows, spacing, typography} from '../config/theme';

const TopHeader = ({isBackButton, Heading, onBack}) => {
  return (
    <View style={styles.container}>
      {isBackButton && (
        <Pressable
          onPress={onBack}
          hitSlop={8}
          accessibilityRole="button"
          accessibilityLabel="Go back"
          style={({pressed}) => [
            styles.backButton,
            pressed && styles.backButtonPressed,
          ]}>
          <ChevronLeft width={22} height={22} color={colors.primary} />
        </Pressable>
      )}
      <Text style={styles.headerText} numberOfLines={1}>
        {Heading}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.background,
    width: '100%',
    height: 64,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 64,
  },
  backButton: {
    position: 'absolute',
    left: spacing.margin,
    width: 40,
    height: 40,
    borderRadius: radii.pill,
    backgroundColor: colors.surface,
    borderWidth: 1,
    borderColor: colors.border,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
    ...shadows.level1,
  },
  backButtonPressed: {
    backgroundColor: colors.surfaceMuted,
    transform: [{scale: 0.96}],
  },
  headerText: {
    ...typography.headlineSm,
    color: colors.text,
    textAlign: 'center',
  },
});

export default TopHeader;
